<div class="app-common-types-datalists-details-xml-section" *ngFor="let commonTypesDataListsDetailsXMLSection of commonTypesDataListsDetailsXMLSections">
  <h4 class="p-2" *ngIf="commonTypesDataListsDetailsXMLSection.subBody">{{ commonTypesDataListsDetailsXMLSection.subBody }}</h4>
  <div [ngClass]="commonTypesDataListsDetailsXMLSection.sectionClass === undefined ? 'body-table' : commonTypesDataListsDetailsXMLSection.sectionClass">
    <div *ngIf="!isSubSection" class="title">{{ commonTypesDataListsDetailsXMLSection.body }}</div>
    <div *ngFor="let xmlData of commonTypesDataListsDetailsXMLSection.xmlDataArray">
      <details *ngIf="xmlData.data.includes('<')" class="border p-3">
        <summary class="flex-text">{{ xmlData.title }}</summary>
        <app-prism-xml [xmlData]="xmlData.data"></app-prism-xml>
      </details>
    </div>
    <app-common-types-datalists-details-xml-section
      [isSubSection]="true"
      [commonTypesDataListsDetailsXMLSections]="commonTypesDataListsDetailsXMLSection.subSections || []"
    ></app-common-types-datalists-details-xml-section>
    <app-common-types-datalists-note-section
      *ngIf="commonTypesDataListsDetailsXMLSection.noteSections!.length > 0"
      [noteWithinTable]="true"
      [noteSections]="commonTypesDataListsDetailsXMLSection.noteSections || []"
    ></app-common-types-datalists-note-section>

    <div *ngIf="commonTypesDataListsDetailsXMLSection.tableSections" class="mrg-top">
      <app-common-types-datalists-table-section [tableSections]="commonTypesDataListsDetailsXMLSection.tableSections"></app-common-types-datalists-table-section>
    </div>
  </div>
</div>
